import {Box, Button, Typography} from '@mui/material';
import {useState} from 'react';
import {t} from 'i18next';

import {useNavigate} from 'react-router-dom';
import {GridOverlay} from '@mui/x-data-grid';
import AurSvgIcon from '../common/aur-svg-icon/AurSvgIcon';
import {ReactComponent as PlusIcon} from '../../assests/svg/plus-icon.svg';
import AurMenu from '../common/aur-menu/AurMenu';

/*
Component for displaying add team member options if no reows are present
*/
const AddTeamMembers = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  /*
  Handler for setting the anchor element when a button is clicked
  */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /*
  Handler for closing a menu or popover
  */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateHandler = () => {
    navigate('/users/bulkupload/add');
  };

  const navigateToUsers = () => {
    navigate('/users/add');
  };

  return (
    <GridOverlay className="grid-overlay">
      <Box className="overlay-outerbox ">
        <Box className="overlay-innerbox">
          <AurSvgIcon src="images/noise.svg" />
          <Typography className="typo-text headline2_size mist-color-100">
            {t('userHomePage.getYourTeamGoing')}
          </Typography>
          <div className="gridoverlay-text">
            <Typography className="body2_size overlay-description"
              sx={{ whiteSpace: 'pre-line' }}>
              {t('userHomePage.auroraGetGoing')}
            </Typography>
          </div>
          <Button
            id="basic-button"
            aria-controls={open ? 'dropdown-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            aria-label={t('label.optionsToAddUsersButton')}
            onClick={handleClick}
            startIcon={<PlusIcon aria-hidden="true" />}
            className="typo-text buttonMedium_size custom-menu-addbutton add-members-button custom-button"
            variant="contained"
            sx={{
              textTransform: 'none',
            }}
          >
            <Typography>{t('userHomePage.addTeamMember')}</Typography>
          </Button>
          <AurMenu
            anchorElement={anchorEl}
            shouldShow={open}
            onClose={handleClose}
            menuItems={[
              {
                label: t('buttons.addNewTeamMember'),
                onClick: navigateToUsers,
              },
              {
                label: t('userHomePage.grpTeamMembers'),
                onClick: navigateHandler,
              },
            ]}
            direction="right"
            aria-labelledby="addUserButton"
          />
        </Box>
      </Box>
    </GridOverlay>
  );
};

export default AddTeamMembers;
